import type { SectionProps } from "../types";
import { problems } from "../data";

export default function ProblemsSection({ isVisible, sectionRef }: SectionProps) {
  return (
    <section
      ref={sectionRef}
      data-section="problems"
      className="py-16 sm:py-20 md:py-24 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div
          className={`text-center mb-10 sm:mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
          }`}
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-[#2a4b7c] mb-3 sm:mb-4 px-4">
            Bạn Đang Gặp Phải Những Vấn Đề Này?
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            Chúng tôi hiểu những khó khăn bạn đang đối mặt
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-5 md:gap-6 max-w-5xl mx-auto">
          {problems.map((problem, index) => (
            <div
              key={index}
              className={`flex items-start gap-3 sm:gap-4 bg-white rounded-xl p-4 sm:p-5 md:p-6 border-2 border-gray-200 transition-all duration-700 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0">
                <i className={`${problem.icon} text-xl sm:text-2xl text-red-600`}></i>
              </div>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed pt-1 sm:pt-2">
                {problem.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

